import { render, staticRenderFns } from "./StackDistricts.vue?vue&type=template&id=bcb5ecbc&scoped=true&"
import script from "./StackDistricts.vue?vue&type=script&lang=js&"
export * from "./StackDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5ecbc",
  null
  
)

export default component.exports